import "@/assets/styles/index.css";
import {
  FullScreenSuspenseFallback,
  ScreenTooSmall,
  useLanguage,
  useResetZoomOnOrientationChange,
  useScreenHeight,
  useScreenWidth,
} from "@crescentapplications/react-ui";
import { Suspense } from "react";
import { createBrowserRouter, RouterProvider } from "react-router";
import routes from "./routes";

// Created once at module level — recreating on every render would reset scroll/state
const router = createBrowserRouter(routes);

export default function App() {
  const { language } = useLanguage();
  const { screenHeight } = useScreenHeight();
  const { screenWidth } = useScreenWidth();

  useResetZoomOnOrientationChange();

  return (
    <>
      {screenWidth < 280 || screenHeight < 280 ? (
        <ScreenTooSmall />
      ) : (
        <Suspense
          fallback={
            <FullScreenSuspenseFallback
              message={language === "ar" ? "يجري التحميل" : "Loading"}
            />
          }
        >
          <RouterProvider router={router} />
        </Suspense>
      )}
    </>
  );
}
